import { render, staticRenderFns } from "./Labeling.vue?vue&type=template&id=0f49dda7&scoped=true&"
import script from "./Labeling.vue?vue&type=script&lang=js&"
export * from "./Labeling.vue?vue&type=script&lang=js&"
import style0 from "./Labeling.vue?vue&type=style&index=0&id=0f49dda7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f49dda7",
  null
  
)

export default component.exports